<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="String(size)"
    :height="String(size)"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    :stroke-width="strokeWidth"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="yn-svg-icon yn-svg-icon-clipboard"
  >
    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" /><rect x="8" y="2" width="8" height="4" rx="1" ry="1" />
  </svg>
</template>

<script setup>
defineProps({
  size: { type: [String, Number], default: '16' },
  strokeWidth: { type: [String, Number], default: 2 },
})
</script>
